import { colors } from "../theme";
import { IdleGroveLogo } from "../components";

interface FooterProps {
  isDark: boolean;
}

export function Footer({ isDark }: FooterProps) {
  return (
    <footer
      className="py-12 px-8 transition-colors duration-[2000ms]"
      style={{
        borderTop: `1px solid ${isDark ? colors.base02 : colors.base2}`,
      }}
    >
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="flex items-center gap-3">
          <IdleGroveLogo size={28} isDark={isDark} />
          <span className="font-medium">Idle Grove</span>
        </div>
        <p
          className="text-sm"
          style={{ color: isDark ? colors.base01 : colors.base1 }}
        >
          © 2025 Idle Grove. Ultra-efficient cold storage infrastructure.
        </p>
      </div>
    </footer>
  );
}
